import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { FAQ, PRIVACY_POLICY, LEGAL_NOTICE, CGU } from '~/const/faq';
import USE_MARKETPLACE from '~/const/marketplace';

var MdmModal = () => import(
/* webpackChunkName: "modal" */
'~/components/atoms/Global/MdmModal.vue');

export default {
  name: 'Mentions',
  components: {
    MdmModal
  },

  data() {
    return {
      showModal: false
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    getDate() {
      var d = new Date();
      return d.getFullYear();
    },

    setLocale() {
      return "".concat(this.locale.market, "/").concat(this.locale.language);
    },

    helpAndFaqsLinks() {
      return FAQ.find(faq => faq.language === this.locale.iso).url;
    },

    legalNoticeLinks() {
      return LEGAL_NOTICE.find(legalNotice => legalNotice.language === this.locale.iso).url;
    },

    privacyPolicyLinks() {
      return PRIVACY_POLICY.find(privacyPolicy => privacyPolicy.language === this.locale.iso).url;
    },

    cguLinks() {
      return CGU.find(cgu => cgu.language === this.locale.iso).links;
    },

    isMarketplaceOpen() {
      return USE_MARKETPLACE(this);
    }

  }),
  methods: {
    editCookies() {
      if (window.tC && window.tC.privacyCenter) {
        window.tC.privacyCenter.showPrivacyCenter();
      }

      return false;
    }

  }
};